import {axios} from 'src/services/api'
import {Result} from 'src/services/api/endpoints/_types'
import {NavigationMenuType} from '../types/navigation-menu.type'

interface GetNavigationMenuParams {
  signal?: AbortSignal
}

interface NavigationMenuProps {
  id: string
  key: string
  parentId: string | null
  label: string
  labelB2c: string | null
  route: string
  icon: string | null
  orderIndex: number
  segment: string | null
  children?: NavigationMenuProps[]
}

type GetNavigationMenuResponse = Result<NavigationMenuProps[]>

const mapper = (res: GetNavigationMenuResponse): NavigationMenuType[] => {
  const mapItem = (item: NavigationMenuProps): NavigationMenuType => ({
    id: item.id,
    key: item.key,
    parentId: item.parentId,
    label: item.label,
    labelB2c: item.labelB2c,
    route: item.route,
    icon: item.icon,
    orderIndex: item.orderIndex,
    segment: item.segment,
    children: item.children ? item.children.map(mapItem) : [],
  })

  return res.data.map(mapItem)
}

const BASE_URL = process.env.REACT_APP_AUTH_BASE_URL

export async function getNavigationMenu({signal}: GetNavigationMenuParams) {
  return await axios.get<GetNavigationMenuResponse>(`${BASE_URL}/navigation/menu`, {signal}).then((res) => mapper(res.data))
}
